import React from 'react';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL; // eslint-disable-line no-process-env

export default function CanonicalRoute({ component: Component, ...rest }) {
  return (
    <Route { ...rest } render={ (props) => [
      <Helmet key="route-helmet">
        <link rel="canonical" href={ `${BASE_URL}${props.match.url}` } />
      </Helmet>,
      <Component key="route-component" { ...props } />
    ] } />
  );
}



// WEBPACK FOOTER //
// ./src/components/CanonicalRoute/index.jsx